import { render, staticRenderFns } from "./ControlsSwitch.vue?vue&type=template&id=03188f5e&"
import script from "./ControlsSwitch.vue?vue&type=script&lang=js&"
export * from "./ControlsSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ControlsSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports